import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { MotionConfig } from "framer-motion";
import { AgeProvider } from "@/components/AgeGate";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ConsentBar, MobileShopBar } from "@/components/Chrome";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import About from "@/pages/About";
import Location from "@/pages/Location";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import SpecialDeals from "@/pages/SpecialDeals";
import MedicalCard from "@/pages/MedicalCard";
import AreasHub from "@/pages/AreasHub";
import StateAreas from "@/pages/StateAreas";
import AreaPage from "@/pages/AreaPage";
import NotFound from "@/pages/NotFound";

const REDIRECTS = ["/about-us", "/contact", "/contact-us", "/shop", "/menu", "/deals"];
const TARGET = { "/about-us": "/about", "/contact": "/location", "/contact-us": "/location", "/shop": "/shop-all", "/menu": "/shop-all", "/deals": "/special-deals" };

function App() {
  useEffect(() => {
    document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());
  }, []);

  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <AgeProvider>
            <a href="#main" className="skip-link">Skip to content</a>
            <SmoothScroll />
            <Header />
            <main id="main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop-all" element={<Shop />} />
                <Route path="/about" element={<About />} />
                <Route path="/location" element={<Location />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/areas-we-serve" element={<AreasHub />} />
                <Route path="/areas-we-serve/:state" element={<StateAreas />} />
                <Route path="/areas-we-serve/:state/:slug" element={<AreaPage />} />
                <Route path="/medical-card" element={<MedicalCard />} />
                <Route path="/special-deals" element={<SpecialDeals />} />
                <Route path="/legal" element={<Legal />} />
                {REDIRECTS.map((p) => <Route key={p} path={p} element={<Navigate to={TARGET[p]} replace />} />)}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <MobileShopBar />
            <ConsentBar />
          </AgeProvider>
        </BrowserRouter>
      </MotionConfig>
    </HelmetProvider>
  );
}

export default App;
